module.exports = __webpack_public_path__ + "img/L2D_Stecker_CCS_150x150.5f959d8d.png";